// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/workspace.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetCallerRequest, GetCallerResponse, GetPeopleNamesRequest, GetPeopleNamesResponse, GetWorkspaceRequest, GetWorkspaceResponse, ListWorkspacesRequest, ListWorkspacesResponse, UpdateWorkspaceRequest, UpdateWorkspaceResponse } from "./workspace_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.WorkspaceService
 */
export const WorkspaceService = {
  typeName: "tracker.v1.WorkspaceService",
  methods: {
    /**
     * @generated from rpc tracker.v1.WorkspaceService.GetCaller
     */
    getCaller: {
      name: "GetCaller",
      I: GetCallerRequest,
      O: GetCallerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.WorkspaceService.ListWorkspaces
     */
    listWorkspaces: {
      name: "ListWorkspaces",
      I: ListWorkspacesRequest,
      O: ListWorkspacesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.WorkspaceService.GetWorkspace
     */
    getWorkspace: {
      name: "GetWorkspace",
      I: GetWorkspaceRequest,
      O: GetWorkspaceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.WorkspaceService.UpdateWorkspace
     */
    updateWorkspace: {
      name: "UpdateWorkspace",
      I: UpdateWorkspaceRequest,
      O: UpdateWorkspaceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.WorkspaceService.GetPeopleNames
     */
    getPeopleNames: {
      name: "GetPeopleNames",
      I: GetPeopleNamesRequest,
      O: GetPeopleNamesResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

